import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/PaymentInformation.graphql';
import { Query, QuerypaymentInformationArgs } from '../../__generated__/globalTypes';

export const usePaymentInformationQuery = (options?: QueryHookOptions<Query, QuerypaymentInformationArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerypaymentInformationArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const usePaymentInformationLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerypaymentInformationArgs>
): QueryResult<Query, QuerypaymentInformationArgs> & {
  getPaymentInformation: LazyQueryExecFunction<Query, QuerypaymentInformationArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getPaymentInformation, result] = useLazyQuery<Query, QuerypaymentInformationArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getPaymentInformation, ...result };
};

export const usePaymentInformationPromiseQuery = () => {
  const client = useApolloClient();

  const getPaymentInformation = useCallback(
    (options?: Omit<QueryOptions<QuerypaymentInformationArgs, Query>, 'query'>) =>
      client.query<Query, QuerypaymentInformationArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getPaymentInformation };
};
// Suspense Query Hooks
export const usePaymentInformationSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerypaymentInformationArgs>
) => {
  const result = useSuspenseQuery<Query, QuerypaymentInformationArgs>(QUERY, {
    ...options
  });

  return result;
};
